import { MARKERS } from './markersConfig';

export function useMarkerTypes() {
  const uniqueMarkers = Array.from(new Map(MARKERS.map(m => [m.id, m])).values());

  const numberingMarkers = uniqueMarkers.filter(m => m.category === 'numbering');
  const checkMarkers     = uniqueMarkers.filter(m => m.category === 'check');
  const listMarkers      = uniqueMarkers.filter(m => m.category === 'list-marker');

  const markersMap = new Map(uniqueMarkers.map(m => [m.id, m]));
  const getMarkerConfig = (markerType: string) => markersMap.get(markerType);

  const getMarkerCategory = (markerType: string): string => getMarkerConfig(markerType)?.category || 'marker';

  const getBaseMarkerType = (markerType: string): string => markerType;

  const getMarkerColorMode = (markerType: string): 'solid' | 'gradient' =>
    getMarkerConfig(markerType)?.backgroundGradient ? 'gradient' : 'solid';

  const getMarkerImagePath = (markerType: string): string => getMarkerConfig(markerType)?.path || '/markers/marker-1.svg';

  return {
    numberingMarkers,
    checkMarkers,
    listMarkers,
    getMarkerConfig,
    getMarkerCategory,
    getBaseMarkerType,
    getMarkerColorMode,
    getMarkerImagePath,
  };
}


